import Qs from 'qs';
import wx from 'weixin-js-sdk';
export const fshare = function (sharetitle,shareimg,sharedesc,sharelink,obj){
	console.log(sharetitle)
	console.log(shareimg)
	console.log(sharedesc)
    console.log(sharelink)
    // console.log(obj)
    let _this=this;
	wx.ready(function () {
		wx.onMenuShareTimeline({ // “分享到朋友圈”及“分享到QQ空间”
			title: sharetitle,
			link: sharelink,
			imgUrl: shareimg,
			success: function () {
                // if(obj){
                //     _this.axios.post(_this.ajaxUrl('crm',"d=wxapi&c=csp_user_track&m=track_save"), Qs.stringify({
                //     	touserid:_this.$store.state.shopdata.userid,
                //     	tousername:_this.$store.state.shopdata.shopname,
                //     	title:obj.title,
                //     	brief:obj.brief,
                //     	type:obj.type,
                //     	idtype:obj.idtype,
                //     	idvalue:obj.idvalue,
                //     })).then((res) => {
                //     })
                // }
			},
		})
		wx.onMenuShareAppMessage({ // “分享给朋友”及“分享到QQ”
			title:sharetitle,
			desc:sharedesc,
			link: sharelink,
			imgUrl: shareimg,
			success: function () {
                // if(obj){
                //     _this.axios.post(_this.ajaxUrl('crm',"d=wxapi&c=csp_user_track&m=track_save"), Qs.stringify({
                //     	touserid:_this.$store.state.shopdata.userid,
                //     	tousername:_this.$store.state.shopdata.shopname,
                //     	title:obj.title,
                //     	brief:obj.brief,
                //     	type:obj.type,
                //     	idtype:obj.idtype,
                //     	idvalue:obj.idvalue,
                //     })).then((res) => {
                //     })
                // }
			},
		})
	})
}
export const settrack = function (obj,type){
    // console.log(obj)
	// this.axios.post(this.ajaxUrl('crm',"d=wxapi&c=csp_user_track&m=track_save"), Qs.stringify({
	// 	touserid:obj.userid?obj.userid:this.$store.state.shopdata.userid,
	// 	tousername:obj.username?obj.username:this.$store.state.shopdata.shopname,
	// 	title:obj.title,
	// 	brief:obj.brief,
	// 	type:obj.type,
	// 	idtype:obj.idtype,
	// 	idvalue:obj.idvalue,
	// })).then((res) => {
	// })
}
